import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Keyboard } from 'swiper/modules';
const $ = window.jQuery;


const $DOM = {};
let newsSwiper;

const domCache = () => {
    $DOM.container = $(".latest-news");
    if (!$DOM.container.length) {
        return;
    }
    $DOM.swiperContainer = $DOM.container.find(".latest-news-swiper-container");
    $DOM.counter = $DOM.container.find(".latest-news-counter");

}

const initSwiper = () => {
    newsSwiper = new Swiper($DOM.swiperContainer[0], {
        modules: [Navigation, Pagination, A11y, Keyboard],
        init: false,
        slidesPerView: 1.1,
        speed: 600,
        spaceBetween: 18,
        preventClicksPropagation: false,
        roundLengths: true,
        loop: false,
        // navigation: {
        //     nextEl: '.swiper-next',
        //     prevEl: '.swiper-prev'
        // },
        pagination: {
            el: '.swiper-pagination-latest-news',
            clickable: true
        },
        keyboard: {
            enabled: true,
            onlyInViewport: true,
        },
        a11y: true,
        watchOverflow: true,
        breakpoints: {
            768: {
                slidesPerView: 2,
                spaceBetween: 40,
            }
        }
    });

    newsSwiper.on("init", onInit);
    newsSwiper.on("slideChange", onSlideChange);
    newsSwiper.init();
}

const onInit = (swiperInstance) => {
    $DOM.swiperContainer.addClass("is-init");
    updateCounter(1, swiperInstance.slides.length);
}

const onSlideChange = (swiperInstance) => {
    updateCounter(swiperInstance.activeIndex + 1, swiperInstance.slides.length);
}

const updateCounter = (currentSlide, nrOfSlide) => {
    $DOM.counter.find("em").eq(0).text(currentSlide.toString().padStart(2, '0'));
    $DOM.counter.find("em").eq(1).text(nrOfSlide.toString().padStart(2, '0'));
}



const latestNewsSlider = {
    init: () => {
        domCache();
        if (!$DOM.container.length) {
            return;
        }
        initSwiper();
    }
};

export default latestNewsSlider;
